// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"439":"655da6011638aa96","762":"bd7956a78428a671","785":"85a36c6a612aa029"}[chunkId] + ".js";
};